import { ResetPasswordComponent } from './reset-password/reset-password.component';

export const CONTAINERS = [ResetPasswordComponent];

export * from './reset-password/reset-password.component';
